import { useState } from "react";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Field } from "@/components/Field";

export const ChangePassword = ({ enabled }) => {
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  if (!enabled) return null;
  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password !== f.confirm) return toast.error("പുതിയ Password രണ്ടിടത്തും ഒരുപോലെ ആയിരിക്കണം");
    setBusy(true);
    try { await api.patch("/auth/change-password", { current_password: f.current_password, new_password: f.new_password }); toast.success("Password മാറ്റി"); setF({ current_password: "", new_password: "", confirm: "" }); }
    catch (err) { toast.error(errMsg(err)); }
    finally { setBusy(false); }
  };
  return (
    <form data-testid="change-password-form" onSubmit={submit} className="card rounded-2xl p-4 space-y-3">
      <div className="flex items-center gap-2"><KeyRound size={15} className="text-[var(--gold)]" /><p className="font-bold text-sm">Password മാറ്റുക</p></div>
      <Field label="നിലവിലെ Password" testId="cp-current" type="password" required value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} />
      <div className="grid grid-cols-2 gap-3">
        <Field label="പുതിയ Password" testId="cp-new" type="password" required minLength={6} value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} />
        <Field label="വീണ്ടും" testId="cp-confirm" type="password" required value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} />
      </div>
      <button data-testid="cp-submit" disabled={busy} className="btn-accent rounded-full h-10 px-5 text-xs font-bold disabled:opacity-60">{busy ? "..." : "മാറ്റുക"}</button>
    </form>
  );
};
